import { PeriodOption } from '@/config/model';
import { dateToJSONLocal } from '@analytical-alley/ui/utils/datepicker';
import { format, parseISO, toDate } from 'date-fns';
import moment from 'moment/moment';

type DateInput = Date | number | string;

export enum DateFormat {
    Normal = 'dd/MM/yyyy',
    Full = 'dd/MM/yyyy HH:mm',
    ISO = 'yyyy-MM-dd',
    URL = 'dd-MM-yyyy',
}

export const makeDateFormatter = (period: PeriodOption | undefined) => {
    if (!period) {
        return undefined;
    }
    switch (period) {
        case 'daily':
            return (dateString: string) => dateString;
        case 'weekly':
            return (dateString: string) => {
                const date = moment.utc(dateString, 'DD-MM-YYYY');
                return `${date.isoWeek()}-${date.isoWeekYear()}`;
            };
        case 'monthly':
            return (dateString: string) => {
                return moment.utc(dateString, 'DD-MM-YYYY').format('MM-YYYY');
            };
        case 'quarterly':
            return (dateString: string) => {
                const date = moment.utc(dateString, 'DD-MM-YYYY'); // replace with your date
                const quarterNumber = date.quarter();

                return `Q${quarterNumber}-${date.year()}`;
            };
        case 'yearly':
            return (dateString: string) => {
                return moment.utc(dateString, 'DD-MM-YYYY').format('YYYY');
            };
    }
};

export function getWeekDays(startDateStr: string): string[] {
    const days: string[] = [];
    const start = moment(startDateStr, 'YYYY-MM-DD');
    for (let i = 0; i < 7; i++) {
        days.push(start.clone().add(i, 'days').format('YYYY-MM-DD'));
    }
    return days;
}

export function getMonthKey(dateStr: string): string {
    return moment(dateStr, 'YYYY-MM-DD').format('YYYY-MM');
}

export function dateToUrlString(date: Date): string {
    return moment.utc(dateToJSONLocal(date), 'YYYY-MM-DD').format('DD-MM-YYYY');
}

export function formatUrlDate(
    urlDate: string | null | undefined,
): string | null {
    if (!urlDate) {
        return null;
    }
    return moment(urlDate, 'DD-MM-YYYY').format('DD/MM/YYYY');
}

export const formatDate = (date: DateInput, formatStr: DateFormat): string => {
    return format(parseDate(date), formatStr);
};

export const parseDate = (date: DateInput): Date => {
    if (typeof date === 'string') {
        return parseISO(date);
    }
    return toDate(date);
};
